/** Meddelanden hämtade från BankIDs integrationsguide och exempelkod */
export const bankIDMessages = {
  // Texter från exempel-appen https://github.com/BankID/SampleCode
  openBankidOnThisDevice: 'Öppna BankID på den här enheten istället',
  openBankidOnAnotherDevice: 'Öppna BankID på en annan enhet istället',
  hintcodeQRoutstandingTransaction:
    'Starta BankID-appen och tryck på QR-ikonen. Skanna sedan QR-koden nedan.',
  hintcodeDesktopoutstandingTransaction:
    'Försöker starta BankID Säkerhetsprogram',
  hintcodeMobileoutstandingTransaction:
    'Klicka på knappen nedan för att starta BankID-appen.',

  hintcodeQrstarted:
    'Starta BankID-appen och tryck på QR-ikonen. Skanna sedan QR-koden nedan.',
  hintcodeDesktopstarted: 'Försöker starta BankID Säkerhetsprogram',
  hintcodeMobilestarted: 'Klicka på knappen nedan för att starta BankID-appen.',

  hintcodeUserSign:
    'Skriv din säkerhetskod i BankID- appen och välj Identifiera eller Skriv under.',
  hintcodedDsktopUserSign:
    'Skriv din säkerhetskod i BankID Säkerhetsprogram och välj Identifiera eller Skriv under.',

  hintcodeUnknown: 'Något gick fel. Försök igen.',
  hintcodeuserCancel: 'Åtgärden avbröts.',

  hintcodeStartFailed:
    'BankID-appen verkar inte finnas i din dator eller telefon. Installera den och skaffa ett BankID hos din internetbank. Installera appen från din appbutik eller https://install.bankid.com.',
  hintcodeQRStartFailed:
    'Skanningen misslyckades. Starta BankID-appen och skanna QR koden. Kontrollera att appen är uppdaterad. Om du inte har appen måste du installera den och skaffa ett BankID hos din internetbank. Installera appen från din appbutik eller https://install.bankid.com.',

  hintcodeExpiredTransaction:
    'BankID-appen svarar inte. Kontrollera att den är startad och att du har internetanslutning. Om du inte har något giltigt BankID kan du skaffa det hos din bank. Försök sedan igen.',
  hintcodeCertificateErr:
    'Det BankID du försöker använda är för gammalt eller spärrat. Använd ett annat BankID eller skaffa ett nytt hos din internetbank.',
  hintcodeAlreadyInProgress:
    'En identifiering eller underskrift för det här personnumret är redan påbörjad. Försök igen.',
  hintcodeRequestTimeout: 'Något gick fel. Försök igen.',
  hintcodeMaintenance: 'Något gick fel. Försök igen.',
  hintcodeInternalError: 'Något gick fel. Försök igen.',

  // Rekommenderade meddelanden hämtade från https://www.bankid.com/utvecklare/guider/teknisk-integrationsguide/rp-anvaendarfall
  // status=pending
  // hintCode=outstandingTransaction
  // hintCode=noClient
  RFA1: 'Starta BankID-appen.',

  // The BankID app is not installed in the mobile device.
  RFA2: 'Du har inte BankID-appen installerad. Kontakta din bank.',

  // errorCode=cancelled
  RFA3: 'Åtgärden avbruten. Försök igen',

  // errorCode=alreadyInProgress
  RFA4: 'En identifiering eller underskrift för det här personnumret är redan påbörjad. Försök igen.',

  // errorCode=requestTimeout
  // errorCode=maintenance (repeatedly)
  // errorCode=internalError
  RFA5: 'Internt tekniskt fel. Försök igen.',

  // status=failed
  // hintCode=userCancel
  RFA6: 'Åtgärden avbruten.',

  // status=failed
  // hintCode=expiredTransaction
  RFA8: 'BankID-appen svarar inte. Kontrollera att den är startad och att du har internetanslutning. Om du inte har något giltigt BankID kan du skaffa ett hos din bank. Försök sedan igen.',

  // status=pending
  // hintCode=userSign
  RFA9: 'Skriv in din säkerhetskod i BankID-appen och välj Identifiera eller Skriv under.',

  //   status=pending
  //   hintCode=outstandingTransaction
  RFA13: 'Försöker starta BankID-appen.',

  // status=pending
  // hintCode=started
  // The user accesses the service using a personal computer.
  RFA14A: `Söker efter BankID, det kan ta en liten stund …
  Om det har gått några sekunder och inget BankID har hittats har du sannolikt inget BankID som går att använda för den aktuella identifieringen/underskriften i den här datorn. Om du har ett BankID-kort, sätt in det i kortläsaren. Om du inte har något BankID kan du skaffa ett hos din bank. Om du har ett BankID på en annan enhet kan du starta din BankID-app där.`,

  // status=pending
  // hintCode=started
  // The user accesses the service using a mobile device.
  RFA14B: `Söker efter BankID, det kan ta en liten stund …
  Om det har gått några sekunder och inget BankID har hittats har du sannolikt inget BankID som går att använda för den aktuella identifieringen/underskriften i den här enheten. Om du inte har något BankID kan du skaffa ett hos din bank. Om du har ett BankID på en annan enhet kan du starta din BankID-app där.`,

  // status=pending
  // hintCode=started
  // The user accesses the service using a personal computer.
  RFA15A: `Söker efter BankID, det kan ta en liten stund …
  Om det har gått några sekunder och inget BankID har hittats har du sannolikt inget BankID som går att använda för den aktuella identifieringen/underskriften i den här datorn. Om du har ett BankID-kort, sätt in det i kortläsaren. Om du inte har något BankID kan du skaffa ett hos din bank.`,

  // status=pending
  // hintCode=started
  // The user accesses the service using a mobile device.
  RFA15B: `Söker efter BankID, det kan ta en liten stund …
  Om det har gått några sekunder och inget BankID har hittats har du sannolikt inget BankID som går att använda för den aktuella identifieringen/underskriften i den här enheten. Om du inte har något BankID kan du skaffa ett hos din bank.`,

  // status=failed
  // hintCode=certificateErr
  RFA16: `Det BankID du försöker använda är för gammalt eller spärrat. Använd ett annat BankID eller skaffa ett nytt hos din bank.`,

  // status=failed
  // hintCode=startFailed
  // RP does not use QR code.
  RFA17A:
    'BankID-appen verkar inte finnas i din dator eller mobil. Installera den och skaffa ett BankID hos din bank. Installera appen från din appbutik eller https://install.bankid.com',

  // status=failed
  // hintCode=startFailed
  // RP uses QR code
  RPA17B:
    'Misslyckades att läsa av QR-koden. Starta BankID-appen och läs av QR-koden. Kontrollera att BankID-appen är uppdaterad. Om du inte har BankID-appen måste du installera den och skaffa ett BankID hos din bank. Installera appen från din appbutik eller https://install.bankid.com.',

  // The name of the link or button used to start the BankID app.
  RFA18: 'Starta BankID-appen.',

  // The user accesses the service using a browser on a personal computer.
  RFA19:
    'Vill du identifiera dig eller skriva under med BankID på den här datorn eller med ett Mobilt BankID?',

  // The user accesses the service using a browser on a mobile device.
  RFA20:
    'Vill du identifiera dig eller skriva under med ett BankID på den här enheten eller med ett BankID på en annan enhet?',

  // status=pending
  // The hintCode is unknown to RP.
  RFA21: 'Identifiering eller underskrift pågår.',

  // An error occured. The errorCode is unknown to RP.
  // status=failed
  // The hintCode is unknown to RP.
  RFA22: 'Okänt fel. Försök igen.',

  // status=pending
  // hintCode=userMrtd
  RFA23: 'Fotografera och läs av din ID-handling med BankID-appen.',
} as const;
